/* eslint-disable lingui/no-unlocalized-strings -- U02: categorias são valores do backend (creditProductReadModel.ts:331-357), mostradas como o legado */
import { msg } from '@lingui/core/macro';
import { defineEnum } from '@/shared/patterns/define-enum';

/**
 * `categoryNameOptions` do legado: o valor vai ao fio, o rótulo aparece; ordem pelo rótulo pt-BR.
 * Só "FINANCIAMENTO DE VEÍCULO" tem valor diferente do rótulo (sem acento).
 */
export const CATEGORY_NAME = defineEnum(
  {
    CCB: { label: 'CCB' },
    'CCB CLEAN': { label: 'CCB CLEAN' },
    'CCB FINANCIAMENTO VE': { label: 'CCB FINANCIAMENTO VE' },
    'CCB PRICE': { label: 'CCB PRICE' },
    CDC: { label: 'CDC' },
    'CDC FGTS': { label: 'CDC FGTS' },
    'COMPRA DE DÍVIDA': { label: 'COMPRA DE DÍVIDA' },
    'CONSIGNADO PRIVADO': { label: 'CONSIGNADO PRIVADO' },
    'CONSIGNADO PRIVADO CDC': { label: 'CONSIGNADO PRIVADO CDC' },
    'CONSIGNADO PRIVADO LEILÃO': { label: 'CONSIGNADO PRIVADO LEILÃO' },
    'CONSIGNADO PÚBLICO': { label: 'CONSIGNADO PÚBLICO' },
    'CAR EQUITY': { label: 'CAR EQUITY' },
    'FINANCIAMENTO DE VEICULO': { label: 'FINANCIAMENTO DE VEÍCULO' },
    'CARTÃO BENEFÍCIO': { label: 'CARTÃO BENEFÍCIO' },
    'CRÉDITO PESSOAL': { label: 'CRÉDITO PESSOAL' },
    DESCONTO: { label: 'DESCONTO' },
    FGTS: { label: 'FGTS' },
    'FGTS COM SEGURO': { label: 'FGTS COM SEGURO' },
    'FINANCIAMENTO ESTUDANTIL': { label: 'FINANCIAMENTO ESTUDANTIL' },
    'CONSIGNADO INSS': { label: 'CONSIGNADO INSS' },
    'NOTA COMERCIAL': { label: 'NOTA COMERCIAL' },
    'PROCESSO TRABALHISTA': { label: 'PROCESSO TRABALHISTA' },
    VEÍCULO: { label: 'VEÍCULO' },
    'ANTECIPAÇÃO DE RECEBÍVEIS': { label: 'ANTECIPAÇÃO DE RECEBÍVEIS' },
    'HOME EQUITY': { label: 'HOME EQUITY' },
  },
  {
    order: [
      'ANTECIPAÇÃO DE RECEBÍVEIS',
      'CAR EQUITY',
      'CARTÃO BENEFÍCIO',
      'CCB',
      'CCB CLEAN',
      'CCB FINANCIAMENTO VE',
      'CCB PRICE',
      'CDC',
      'CDC FGTS',
      'COMPRA DE DÍVIDA',
      'CONSIGNADO INSS',
      'CONSIGNADO PRIVADO',
      'CONSIGNADO PRIVADO CDC',
      'CONSIGNADO PRIVADO LEILÃO',
      'CONSIGNADO PÚBLICO',
      'CRÉDITO PESSOAL',
      'DESCONTO',
      'FGTS',
      'FGTS COM SEGURO',
      'FINANCIAMENTO DE VEICULO',
      'FINANCIAMENTO ESTUDANTIL',
      'HOME EQUITY',
      'NOTA COMERCIAL',
      'PROCESSO TRABALHISTA',
      'VEÍCULO',
    ],
  },
);

/** `termStatusOptionsList` (creditProductReadModel.ts:359-364), traduzido pelo valor técnico (U33). */
export const TERM_STATUS = defineEnum({
  Current: { label: msg`Vigente` },
  Future: { label: msg`Futura` },
  Expired: { label: msg`Expirada` },
  ProposalPending: { label: msg`Propostas Pendentes` },
});
